import { createContext, useContext } from 'react';
import { noop } from 'rxjs';
import type { Collection } from '@/hooks/collections/use-collections';

type CollectionMenuContextType = {
  selected: Collection | null;
  position: [number, number] | null;
  setSelected: (collection: Collection | null, position?: [number, number]) => void;
  forward: (collectionId: number) => void;
};

export const CollectionMenuContext = createContext<CollectionMenuContextType>({
  selected: null,
  position: null,
  setSelected: noop,
  forward: noop,
});

export const CollectionMenuProvider = CollectionMenuContext.Provider;

export default function useCollectionMenuContext() {
  const context = useContext(CollectionMenuContext);
  if (!context) {
    throw new Error('useCollectionMenuContext must be used within a CollectionMenuProvider');
  }
  return context;
}
